module.exports = (__webpack_require__(781))(36968);